export const ValuesGrid = ({ children }: { children: React.ReactNode }) => (
    <div className="bg-accent rounded-lg w-full grid grid-cols-1 lg:grid-cols-3 items-start">{children}</div>
)
